// Some extension are firing the POST call for an unknown reason
// This is a quick fix to prevent the route to be called if the response received does not match the expected type

// @ts-expect-error: Unreachable code error
import { RealexHpp } from "itsf-ui-common";

export interface IInitHppParams {
    iframeParams: {
        idOfEmbeddedButton: string;
        idOfTargetIframe: string;
        callback: (hppResponse: string) => void;
        hppRequest: unknown;
    };
    hppUrl: string | undefined;
}

const preventCallFromExternalSource = (hppResponse: unknown, callBackFunction: (hppResponse: string) => void) => {
    let jsonParsedResponse = hppResponse;

    if (typeof hppResponse === "string") {
        jsonParsedResponse = JSON.parse(hppResponse);

        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        if (jsonParsedResponse.MERCHANT_RESPONSE_URL) {
            return callBackFunction(hppResponse);
        }
    }

    return null;
};

export const initHppIframe = (initProps: IInitHppParams) => {
    const { iframeParams, hppUrl } = initProps;
    const { idOfEmbeddedButton, idOfTargetIframe, callback, hppRequest } = iframeParams;

    const callBackWrapper = (response: unknown) => {
        preventCallFromExternalSource(response, callback);
    };

    RealexHpp.setHppUrl(hppUrl);
    RealexHpp.embedded.init(idOfEmbeddedButton, idOfTargetIframe, callBackWrapper, hppRequest);
};
